<template>
  <div>
    <el-form ref="form" :model="newForm" size="mini">
      <el-row :gutter="10" class="head_text">
        <el-col :span="12">
          <div>
            {{ $l('form_original_customer_information') || '原客户基本信息' }}
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            {{
              $l('form_customer_information_after_change') ||
              '变更后客户基本信息'
            }}
          </div>
        </el-col>
        <el-col :span="24">
          <el-divider></el-divider>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_custName') || '客户公司名称'">
            <el-input v-model="formData.custName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_custName') || '客户公司名称'"
            prop="custName"
          >
            <el-input
              v-if="newForm.custName"
              v-model="newForm.custName"
              readonly
              :flag="'flag'"
            />
            <el-input v-else v-model="formData.custName" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_businessLicense') || '客户公司税号'"
          >
            <el-input v-model="formData.businessLicense" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_businessLicense') || '客户公司税号'"
            prop="businessLicense"
          >
            <el-input
              v-if="newForm.businessLicense"
              v-model="newForm.businessLicense"
              readonly
              :flag="'flag'"
            />
            <el-input v-else v-model="formData.businessLicense" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_custAddress') || '客户经营地址'">
            <el-input v-model="formData.custAddress" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_custAddress') || '客户经营地址'"
            prop="custAddress"
          >
            <el-input
              v-if="newForm.custAddress"
              v-model="newForm.custAddress"
              readonly
              :flag="'flag'"
            />
            <el-input v-else v-model="formData.custAddress" readonly />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$l('form_label_region') || '所在国家'">
                <el-input v-model="formData.regionName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_contactMobile') || '客户联系电话'"
              >
                <el-input v-model="formData.contactMobile" readonly />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_region') || '所在国家'"
                prop="regionCode"
              >
                <el-input
                  v-if="newForm.regionName"
                  v-model="newForm.regionName"
                  readonly
                  :flag="'flag'"
                />
                <el-input v-else v-model="formData.regionName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_contactMobile') || '客户联系电话'"
                prop="contactMobile"
              >
                <el-input
                  v-if="newForm.contactMobile"
                  v-model="newForm.contactMobile"
                  readonly
                  :flag="'flag'"
                />
                <el-input v-else v-model="formData.contactMobile" readonly />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row :gutter="10" class="head_text mt-4">
        <el-col :span="12">
          <div>
            {{
              $l('form_original_business_setting_information') ||
              '原业务设置信息'
            }}
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            {{
              $l('form_business_setting_information_after_change') ||
              '变更后业务设置信息'
            }}
          </div>
        </el-col>
        <el-col :span="24">
          <el-divider></el-divider>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_custShortName') || '客户简称'"
              >
                <el-input v-model="formData.custShortName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_customerBizType') || '客户类型'"
              >
                <el-input v-model="formData.customerBizTypeName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_customerType') || '客户性质'"
                prop="customerType"
              >
                <el-input v-model="formData.customerTypeName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('form_label_sales') || '接待人员'">
                <el-input v-model="formData.salesName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_riskAssessor') || '财务风险评估人'"
              >
                <el-input v-model="formData.riskAssessorName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('form_label_managerApproval') || '部门主管审批人'">
                <el-input v-model="formData.managerApprovalByName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('form_label_approver') || '审批负责人'">
                <el-input v-model="formData.approverName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_dep') || '业务部门'">
                <el-input v-model="formData.depName" readonly />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_custShortName') || '客户简称'"
                prop="custShortName"
              >
                <el-input
                  v-if="newForm.custShortName"
                  v-model="newForm.custShortName"
                  readonly
                  :flag="'flag'"
                />
                <el-input v-else v-model="formData.custShortName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_customerBizType') || '客户类型'"
                prop="customerBizType"
              >
                <el-input
                  v-if="newForm.v_customerBizType"
                  v-model="newForm.v_customerBizType"
                  readonly
                  :flag="'flag'"
                />
                <el-input
                  v-else
                  v-model="formData.customerBizTypeName"
                  readonly
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_customerType') || '客户性质'"
                prop="customerType"
              >
                <el-input
                  v-if="newForm.v_customerType"
                  v-model="newForm.v_customerType"
                  readonly
                  :flag="'flag'"
                />
                <el-input v-else v-model="formData.customerTypeName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_sales') || '接待人员'"
                prop="salesCode"
              >
                <el-input
                  v-if="newForm.salesName"
                  v-model="newForm.salesName"
                  readonly
                  :flag="'flag'"
                />
                <el-input v-else v-model="formData.salesName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_riskAssessor') || '财务风险评估人'"
                prop="riskAssessorCode"
              >
                <el-input
                  v-if="newForm.riskAssessorName"
                  v-model="newForm.riskAssessorName"
                  readonly
                  :flag="'flag'"
                />
                <el-input v-else v-model="formData.riskAssessorName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_managerApproval') || '部门主管审批人'"
                prop="managerApprovalBy"
              >
                <el-input
                  v-if="newForm.managerApprovalBy"
                  v-model="newForm.managerApprovalByName"
                  readonly
                  :flag="'flag'"
                />
                <el-input v-else v-model="formData.managerApprovalByName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_approver') || '审批负责人'"
                prop="approverCode"
              >
                <el-input
                  v-if="newForm.approverName"
                  v-model="newForm.approverName"
                  readonly
                  :flag="'flag'"
                />
                <el-input v-else v-model="formData.approverName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_dep') || '业务部门'"
                prop="depCode"
              >
                <el-input
                  v-if="newForm.orgDepFullName"
                  v-model="newForm.orgDepFullName"
                  readonly
                  :flag="'flag'"
                />
                <el-input v-else v-model="formData.depName" readonly />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <div class="mt-3 mb-1">
            <h6>
              <span class="text-danger">*</span>
              <span style="color: #101010">
                {{
                  $l('form_label_reason_change_explanation') || '变更原因说明'
                }}
              </span>
            </h6>
          </div>
          <el-form-item prop="remark">
            <div>
              <el-input
                v-model="newForm.remark"
                type="textarea"
                :rows="6"
                :maxlength="500"
                show-word-limit
                clearable
                readonly
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    formData: { type: Object, default: () => {} },
  },
  data() {
    return {
      newForm: {},
    }
  },
  computed: {},
  watch: {
    formData: {
      handler() {
        if (this.formData.updateContent) {
          this.newForm = JSON.parse(this.formData.updateContent)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-input .el-input__inner[readonly='readonly'] {
    background-color: #f9f9f9;
    border: none !important;
  }
  .el-input .el-input__inner[flag='flag'] {
    color: red;
  }
}
.head_text {
  color: #101010;
  font-size: 16px;
  font-weight: 600;
}
</style>
